var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlmaraiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.802,
    height: 43.029,
    viewBox: "0 0 71.802 43.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-39.351 -33.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(40.43 33.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0 29.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(15.307 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M98.233,150.073l-.064-.012a2.414,2.414,0,0,1-2.052-2.661h0a.226.226,0,0,1,0-.033h0v-10.59H98.5v10.315c.051,1.068.188,1.149.795,1.279h0l.486.064-1.366,1.543-.1.114-.086-.019Z",
    transform: "translate(-96.117 -136.776)",
    fill: "#002581"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(20.135 4.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M124.7,152.565a5.134,5.134,0,0,0-3.028.877h0v6.278h-2.4V153.9a.1.1,0,0,1,0-.021h0c0-.622-.105-.927-.227-1.044h0a1.047,1.047,0,0,0-.784-.266h0a5.126,5.126,0,0,0-3.014.877h0v6.278h-2.4v-8.711h2.4v.716a7.017,7.017,0,0,1,3.226-.958h.016a3.073,3.073,0,0,1,2.635,1.349h0a7.367,7.367,0,0,1,3.809-1.349h0a3.855,3.855,0,0,1,2.656.972h0a4.161,4.161,0,0,1,.764,2.989h0v4.992h-2.609v-5.838c0-.629-.1-.932-.231-1.051h0a1.074,1.074,0,0,0-.8-.267h0",
    transform: "translate(-112.843 -150.767)",
    fill: "#002581"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(36.933 4.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M175.22,159.931h-.008a4.088,4.088,0,0,1-2.954-1.132h0a4.579,4.579,0,0,1-1.22-3.348h0v-.013h0a4.515,4.515,0,0,1,1.5-3.646h0a5.459,5.459,0,0,1,3.533-1.1h0a10.56,10.56,0,0,1,4.4,1.018h0l.088.04v7.917H178.15v-.854a4.169,4.169,0,0,1-2.916,1.117h-.014Zm.7-7.536c-1.512,0-2.3,1.172-2.325,2.873h0c.018,1.618.934,2.667,2.2,2.668h0a4.275,4.275,0,0,0,2.348-.745h0v-4.4a6.964,6.964,0,0,0-2.217-.4h-.008Z",
    transform: "translate(-171.037 -150.694)",
    fill: "#002581"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M54.814,149.768l-4.761-9.873-2.46,5.066h4.689l-.068.2c-.214.611-.355,1.007-.7,1.207h0a3.028,3.028,0,0,1-1.39.171h-3.3l-1.566,3.227H43.089L49.45,136.86l.041-.084h2.182l6.148,12.992Zm-5.229-12.69v0Z",
    transform: "translate(-43.089 -136.776)",
    fill: "#002581"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(65.29 4.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M269.428,159.72h-.149v-7.98l2.4-.972v8.952Z",
    transform: "translate(-269.279 -150.768)",
    fill: "#002581"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(48.23 4.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M210.174,159.711V151h2.4v.7a5.264,5.264,0,0,1,3.2-.945h0c.094,0,.191,0,.287,0h0l.179.005-.4,2-.147-.028a4.606,4.606,0,0,0-.8-.068h0a4.1,4.1,0,0,0-2.314.639h0v6.409Z",
    transform: "translate(-210.174 -150.754)",
    fill: "#002581"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(54.055 4.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M234.54,159.931h-.012a4.09,4.09,0,0,1-2.951-1.131h0a4.584,4.584,0,0,1-1.22-3.345h0a.106.106,0,0,1,0-.021h0a4.513,4.513,0,0,1,1.5-3.641h0a5.455,5.455,0,0,1,3.534-1.1h0a10.557,10.557,0,0,1,4.4,1.018h0l.089.041v7.916h-2.405v-.856a4.157,4.157,0,0,1-2.916,1.119h-.014Zm.7-7.536c-1.511.006-2.3,1.172-2.322,2.872h0c.018,1.62.93,2.668,2.2,2.669h0a4.265,4.265,0,0,0,2.348-.745h0v-4.4a6.956,6.956,0,0,0-2.216-.4h-.01Z",
    transform: "translate(-230.355 -150.694)",
    fill: "#002581"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(64.924 0.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M269.552,142.263a1.491,1.491,0,0,1-1.542-1.435h0a1.491,1.491,0,0,1,1.542-1.435h0a1.5,1.5,0,0,1,1.547,1.435h0a1.5,1.5,0,0,1-1.547,1.435Z",
    transform: "translate(-268.01 -139.393)",
    fill: "#002581"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(0.694 8.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(64.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M267.654,78.711V64.461h2.859v14.25Z",
    transform: "translate(-267.654 -64.461)",
    fill: "#002581"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(32.34 3.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M157.531,86.185v-10.4l2.861-.819V86.185Z",
    transform: "translate(-157.531 -74.968)",
    fill: "#002581"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(0 3.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M71.424,85.135h3.609v1.918H63.581a2.383,2.383,0,0,1-1.978-.665h0a5.326,5.326,0,0,1-.818-2.2h0c-.3-1.3-.461-2.073-.671-2.984h0a3.6,3.6,0,0,0-.458-1.295h0c-.175-.218-.376-.321-.883-.329h-.649l1.545,7.476H49.47l.013-.025a3.983,3.983,0,0,1-3.113-1.5h0a5.783,5.783,0,0,1-.877-3.471h0V80.094h0v-.08l.041-.07a25.262,25.262,0,0,1,2.3-3.162h0l.527-.613v6.165a3.642,3.642,0,0,0,.461,2.285h0c.294.357.826.517,1.819.517H56.49l-1.5-7.445h3.863c1.984-.012,3,1.433,3.374,3.23h0c.214.973.506,2.255.649,2.886h0a3.683,3.683,0,0,0,.345,1.182h0c.06.088.226.147.815.147h2.751a3.012,3.012,0,0,1-1.056-2.4h0A3.4,3.4,0,0,1,67.621,79.7h0a8.259,8.259,0,0,1,3.959-.893h0a8.828,8.828,0,0,1,3.051.511h0l.195.073v1.617h0v.274l-.272.026-.2.017-.1-.1a3.741,3.741,0,0,0-2.7-.825h0a3.7,3.7,0,0,0-2.287.552h0a2.059,2.059,0,0,0-.692,1.759h0a2.207,2.207,0,0,0,.732,1.827h0a3.288,3.288,0,0,0,2.114.592Z",
    transform: "translate(-45.493 -76.168)",
    fill: "#002581"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(31.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M154.56,83.4l-.13-.09V80.938l.236-.051.313-.065.112.178a3.406,3.406,0,0,0,2.877,1.464h0a2.855,2.855,0,0,0,1.967-.6h0a3.292,3.292,0,0,0,.84-2.583h0v-4.9h0v-.3h2.862v.3c0,1.218.208,1.788.545,2.057h0a3.232,3.232,0,0,0,1.984.365h2c-.008-.1-.011-.2-.011-.3h0a4.041,4.041,0,0,1,1.55-3.321h0a5.46,5.46,0,0,1,3.332-1.049h0a5.486,5.486,0,0,1,3.323,1.036h0a4,4,0,0,1,1.555,3.31h0c0,.11,0,.218-.011.322h2.52c.981,0,1.236-.2,1.54-.6h0a4.142,4.142,0,0,0,.463-2.4h0V64.461h2.863v9.274a5.874,5.874,0,0,1-.851,3.449h0a4.056,4.056,0,0,1-3.315,1.528h0l-.008.014H177.3a4.888,4.888,0,0,1-4.27,2.092h0a4.891,4.891,0,0,1-4.288-2.092H165.8l-.009-.008a7.991,7.991,0,0,1-2.149-.309h0v1.2h0a4.287,4.287,0,0,1-1.644,3.493h0a6.052,6.052,0,0,1-3.734,1.169h0a7.487,7.487,0,0,1-3.7-.876Zm18.208-4.281a1.677,1.677,0,0,0,1.535-.727h0a3.51,3.51,0,0,0,.427-1.885h0a3.569,3.569,0,0,0-.449-1.912h0a1.663,1.663,0,0,0-1.514-.749h0a1.632,1.632,0,0,0-1.5.738h0a3.548,3.548,0,0,0-.435,1.9h0a3.594,3.594,0,0,0,.418,1.9h0a1.632,1.632,0,0,0,1.515.735Z",
    transform: "translate(-154.43 -64.461)",
    fill: "#002581"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(3.758 15.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M58.513,119.177a1.507,1.507,0,0,1,1.558-1.45h0a1.51,1.51,0,0,1,1.562,1.45h0a1.509,1.509,0,0,1-1.562,1.449h0a1.507,1.507,0,0,1-1.558-1.449Z",
    transform: "translate(-58.513 -117.727)",
    fill: "#002581"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(7.442 15.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M71.275,119.177a1.509,1.509,0,0,1,1.56-1.45h0a1.509,1.509,0,0,1,1.559,1.45h0a1.508,1.508,0,0,1-1.559,1.449h0a1.509,1.509,0,0,1-1.56-1.449Z",
    transform: "translate(-71.275 -117.727)",
    fill: "#002581"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(13.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M109.249,53.972c-.18-.135-.372-.274-.565-.406-.156-.108-.316-.212-.479-.318-.21-.134-.426-.265-.645-.395-.16-.091-.322-.183-.489-.274-.225-.122-.455-.243-.691-.361q-.207-.1-.417-.206l-.009,0c-.247-.12-.5-.234-.752-.348l.007,0a56.531,56.531,0,0,0-12.243-3.6,4.082,4.082,0,0,0-3.926,1.61c-.291.424-.069.732.314.742,12.4-.019,17.881,2.833,19.361,3.775Z",
    transform: "translate(-88.907 -43.922)",
    fill: "#00a1ed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(5.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M170.315,36.663c-1.041-.247-2.047-.434-3-.579-10.775,2.446-16.923,6.91-17.88,7.649.236.117.466.239.691.361C157.729,38.813,168.489,36.945,170.315,36.663Z",
    transform: "translate(-137.429 -35.436)",
    fill: "#009d3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M178.336,40.89a30.865,30.865,0,0,0-3.343-1.169c-14.194,2.5-20.707,6.7-21.465,7.234.219.13.435.261.645.395C164.567,42.156,177.565,40.956,178.336,40.89Z",
    transform: "translate(-140.337 -38.023)",
    fill: "#33a437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M142.215,34.177a1.955,1.955,0,0,0-2.15-.042c-.19.088-.172.224.024.385a29.4,29.4,0,0,1,4.476,4.566c.208-.149.42-.3.636-.442A19.9,19.9,0,0,0,142.215,34.177Z",
    transform: "translate(-130.667 -33.838)",
    fill: "#00a1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M126.98,36.285a2.771,2.771,0,0,0-3.089.22c-.2.183-.169.311.079.42a49.857,49.857,0,0,1,8.022,4.432c.183-.145.373-.289.565-.431A38.54,38.54,0,0,0,126.98,36.285Z",
    transform: "translate(-119.161 -35.316)",
    fill: "#00a1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M110.6,40.829a2.839,2.839,0,0,0-2.661.695c-.211.219-.108.386.236.466a37.651,37.651,0,0,1,11.145,3.888q.332-.292.689-.584A57.157,57.157,0,0,0,110.6,40.829Z",
    transform: "translate(-107.833 -38.737)",
    fill: "#00a1ed"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M149.061,38.916a36.107,36.107,0,0,1,9.739-4.7c.941.006,2.3.055,3.918.229-1.148.159-8.262,1.393-16.608,7.748-.247-.12-.5-.234-.752-.348q.315-.3.659-.6t.689-.584c.212-.172.426-.345.652-.516.183-.145.373-.289.565-.431.165-.121.334-.241.5-.361C148.632,39.209,148.844,39.062,149.061,38.916Z",
    transform: "translate(-129.062 -34.11)",
    fill: "#00973d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M157.987,53.06a69.3,69.3,0,0,1,28.729-3.77,22.993,22.993,0,0,0-3.986-2.558c-15.432,1.406-24.222,5.4-25.309,5.922q.29.2.559.4Z",
    transform: "translate(-137.645 -43.01)",
    fill: "#54ab34"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(39.351 45.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M40.182,74.1a.83.83,0,0,1,.718.411.843.843,0,0,1,.113.421.834.834,0,0,1-.113.42.8.8,0,0,1-.3.3.824.824,0,0,1-.421.113.811.811,0,0,1-.418-.113.8.8,0,0,1-.3-.3.819.819,0,0,1-.113-.42.828.828,0,0,1,.113-.421.8.8,0,0,1,.3-.3A.819.819,0,0,1,40.182,74.1Zm0,.1a.73.73,0,1,0,.731.73.73.73,0,0,0-.731-.73Zm-.358.245h.346a.325.325,0,0,1,.269.111.335.335,0,0,1,.072.221.261.261,0,0,1-.154.247l.187.346-.065.051H40.4l-.18-.353h-.255v.353h-.142Zm.341.149h-.2v.322h.216a.182.182,0,0,0,.13-.043.176.176,0,0,0,.05-.13.162.162,0,0,0-.022-.087A.2.2,0,0,0,40.165,74.594Z",
    transform: "translate(-39.351 -74.099)",
    fill: "#002581"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(109.491 63.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M283.172,136.513a.83.83,0,0,1,.718.411.841.841,0,0,1,.113.421.831.831,0,0,1-.113.42.8.8,0,0,1-.3.3.823.823,0,0,1-.42.113.811.811,0,0,1-.418-.113.8.8,0,0,1-.3-.3.821.821,0,0,1-.113-.42.832.832,0,0,1,.113-.421.8.8,0,0,1,.3-.3A.82.82,0,0,1,283.172,136.513Zm0,.1a.73.73,0,1,0,.516.214A.7.7,0,0,0,283.172,136.614Zm-.358.245h.346a.325.325,0,0,1,.269.111.335.335,0,0,1,.072.221.26.26,0,0,1-.154.247l.188.346-.065.05h-.079l-.18-.353h-.255v.353h-.142Zm.341.149h-.2v.322h.216a.181.181,0,0,0,.13-.043.176.176,0,0,0,.05-.13.165.165,0,0,0-.022-.087A.2.2,0,0,0,283.155,137.008Z",
    transform: "translate(-282.341 -136.513)",
    fill: "#002581"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlmaraiLogo);
export default __webpack_public_path__ + "static/media/almaraiLogo.6270dabd617394c25fafead978dee5b8.svg";
export { ForwardRef as ReactComponent };